function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.9625 11.7065C17.9619 11.7065 10.1163 15.8827 5.93457 22.0511C10.1163 28.2196 17.9619 32.3958 26.9625 32.3958C35.9631 32.3958 43.8087 28.2196 47.9904 22.0511C43.7689 15.8827 35.9233 11.7065 26.9625 11.7065Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9617 11.7069V11.3237C17.8416 11.3237 9.87649 15.5382 5.57532 21.8598L5.41602 22.0514L5.57532 22.243C9.83666 28.5263 17.8416 32.7791 26.9617 32.7791C36.0818 32.7791 44.0469 28.5646 48.3481 22.243L48.5074 22.0514L48.3481 21.8598C44.0867 15.5765 36.0818 11.3237 26.9617 11.3237V11.7069V12.09C35.803 12.09 43.5292 16.1895 47.671 22.2813L47.9897 22.0897L47.671 21.8981C43.569 27.9516 35.8428 32.0894 26.9617 32.0894C18.1204 32.0894 10.3942 27.9899 6.25235 21.8981L5.93375 22.0897L6.25235 22.2813C10.3544 16.2278 18.0806 12.09 26.9617 12.09V11.7069Z",
  fill: "#4A4A4A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9907 15.152L8.79395 16.8032L10.7556 19.2185L12.9523 17.5672L10.9907 15.152Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.8385 22.0515C36.8385 27.3003 32.4178 31.5531 26.9617 31.5531C21.5056 31.5531 17.085 27.3003 17.085 22.0515C17.085 16.8026 21.5056 12.5498 26.9617 12.5498C32.4178 12.5498 36.8385 16.8026 36.8385 22.0515Z",
  fill: "#2F68CA"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8393 22.0513H36.441C36.441 24.58 35.3657 26.8405 33.6532 28.488C31.9407 30.1354 29.5512 31.1699 26.9625 31.1699C24.334 31.1699 21.9843 30.1354 20.2718 28.488C18.5593 26.8405 17.484 24.5417 17.484 22.0513C17.484 19.5227 18.5593 17.2622 20.2718 15.6147C21.9843 13.9672 24.3739 12.9328 26.9625 12.9328C29.591 12.9328 31.9407 13.9672 33.6532 15.6147C35.3657 17.2622 36.441 19.561 36.441 22.0513H36.8393H37.2375C37.2375 16.5725 32.6178 12.1665 26.9625 12.1665C21.2675 12.1665 16.6875 16.6108 16.6875 22.0513C16.6875 27.5301 21.3073 31.9362 26.9625 31.9362C32.6576 31.9362 37.2375 27.4918 37.2375 22.0513H36.8393Z",
  fill: "#4A4A4A"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.7852 22.0513C30.7852 24.0819 29.0727 25.7294 26.9619 25.7294C24.8512 25.7294 23.1387 24.0819 23.1387 22.0513C23.1387 20.0207 24.8512 18.3733 26.9619 18.3733C29.0727 18.3733 30.7852 20.0207 30.7852 22.0513Z",
  fill: "#4A4A4A"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M30.785 22.0514H30.3867C30.3867 22.9709 29.9885 23.7755 29.3911 24.3885C28.7539 25.0015 27.9175 25.3463 26.9617 25.3463C26.0059 25.3463 25.1696 24.9632 24.5324 24.3885C23.8952 23.7755 23.5367 22.9709 23.5367 22.0514C23.5367 21.1319 23.935 20.3273 24.5324 19.7143C25.1696 19.1013 26.0059 18.7565 26.9617 18.7565C27.9175 18.7565 28.7539 19.1396 29.3911 19.7143C30.0283 20.3273 30.3867 21.1319 30.3867 22.0514H30.785H31.1832C31.1832 19.8292 29.3114 17.9902 26.9617 17.9902C24.6519 17.9902 22.7402 19.7909 22.7402 22.0514C22.7402 24.2735 24.612 26.1125 26.9617 26.1125C29.2716 26.1125 31.1832 24.3118 31.1832 22.0514H30.785Z",
  fill: "#4A4A4A"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M2.38953 7.60742H0V9.52295H2.38953V7.60742Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.0016 0.710938C27.4397 0.710938 27.7981 1.05575 27.7981 1.47719V6.84093C27.7981 7.26237 27.4397 7.60718 27.0016 7.60718C26.5635 7.60718 26.2051 7.26237 26.2051 6.84093V1.47719C26.2051 1.05575 26.5635 0.710938 27.0016 0.710938Z",
  fill: "#F8886E"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.0016 43.2386C27.4397 43.2386 27.7981 42.8938 27.7981 42.4724V37.1085C27.7981 36.6871 27.4397 36.3423 27.0016 36.3423C26.5635 36.3423 26.2051 36.6871 26.2051 37.1085V42.4724C26.2051 42.8938 26.5635 43.2386 27.0016 43.2386Z",
  fill: "#F8886E"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.3222 2.85642C36.6408 3.16292 36.6408 3.62267 36.3222 3.92918L32.3795 7.72215C32.0609 8.02865 31.5829 8.02865 31.2643 7.72215C30.9457 7.41565 30.9457 6.95589 31.2643 6.64939L35.2071 2.85642C35.4859 2.58823 36.0036 2.58823 36.3222 2.85642Z",
  fill: "#F8886E"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.3222 40.7097C36.6408 40.4032 36.6408 39.9435 36.3222 39.637L32.3795 35.8439C32.0609 35.5374 31.5829 35.5374 31.2643 35.8439C30.9457 36.1504 30.9457 36.6102 31.2643 36.9167L35.2071 40.7097C35.4859 40.9779 36.0036 40.9779 36.3222 40.7097Z",
  fill: "#F8886E"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6833 2.85642C17.3647 3.16292 17.3647 3.62267 17.6833 3.92918L21.626 7.72215C21.9446 8.02865 22.4225 8.02865 22.7411 7.72215C23.0598 7.41565 23.0598 6.95589 22.7411 6.64939L18.7984 2.85642C18.5196 2.58823 18.0019 2.58823 17.6833 2.85642Z",
  fill: "#F8886E"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6833 40.7097C17.3647 40.4032 17.3647 39.9435 17.6833 39.637L21.626 35.8439C21.9446 35.5374 22.4225 35.5374 22.7411 35.8439C23.0598 36.1504 23.0598 36.6102 22.7411 36.9167L18.7984 40.7097C18.5196 40.9779 18.0019 40.9779 17.6833 40.7097Z",
  fill: "#F8886E"
});

var SvgVision = function SvgVision(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 44,
    viewBox: "0 0 49 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVision, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vision.f8a006d0.svg";
export { ForwardRef as ReactComponent };